import { Device } from '@capacitor/device';
import { appLanguage } from '../appConfig';

const baseTest = window.location.pathname.match(/(.*\/)/);
const base = baseTest ? baseTest[1] : '/';
const config = await fetch(`${base}config.json`).then(r => r.ok ? r.json() : null).catch(e => console.info(e)) || null;
const supportedLocales = ['nl-NL', 'de-DE', 'en-GB', 'fr-FR'];

function normalizeLocale(tag: string | null | undefined): string {
    // fallback on 'nl-NL' if tag isn't available or supported
    if (!tag) return 'nl-NL';
    if (supportedLocales.includes(tag)) return tag;
    const language = tag.split('-')[0].toLowerCase();
    const match = supportedLocales.find(l => l.split('-')[0].toLowerCase() === language);
    return match ?? 'nl-NL';
}
async function resolveDeviceLocale(): Promise<string> {
    try {
        const { platform } = await Device.getInfo();
        if (platform === 'android' || platform === 'ios') {
            // get device language in native mobile app
            const { value } = await Device.getLanguageTag();
            return normalizeLocale(value);
        }
        // get browser language in web app
        return normalizeLocale(navigator.language);
    } catch {
        return normalizeLocale(navigator.language);
    }
}

const deviceLocale = await resolveDeviceLocale();

// Set the desired locale globally
export class Locale {
    static get locale(): string {
        // Always use appLanguage from the theme if set.
        // else use user set locale from localStorage if set
        // else use defaultLocale from config.json if set
        // else use device/browser locale
        // fallback on 'nl-NL'
        return appLanguage || localStorage.getItem('language') || config?.defaultLocale || deviceLocale || 'nl-NL'
    }
}

export default Locale;
